import { FC, useEffect, useState } from 'react';
import VerifyMember from '../../components/join/VerifyMember';
import Verify from '../../components/join/Verify';
import UpdatePassword from '../../components/join/UpdatePassword';
import { ACCOUNT_STATUS_TYPE } from './login';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import Spinner from '../../components/Spinner';


interface IProps {
  inputIdRef: any;
  setLoginCertificationVisible: any;
  onSetFindModal: any;
}

export enum FindContent {
  Member,
  Verify,
  UpdatePassword
}

const FindPassword: FC<IProps> = ({
  inputIdRef,
  setLoginCertificationVisible,
  onSetFindModal
}) => {

  const { isLoading } = useSelector((state: RootState) => state.find);
  const [content, setContent] = useState(FindContent.Member);

  const changeContent = (content: any) => () => setContent(content);
  const setVerifyPage = changeContent(FindContent.Verify);
  const setUpdatePasswordPage = changeContent(FindContent.UpdatePassword);

  const onGoLogin = () => {
    setLoginCertificationVisible(false);
    inputIdRef.current.focus();
  }

  const renderTabContent = () => {
    switch (content) {
      case FindContent.Member:
        return (
          <VerifyMember
            handleNextPage={setVerifyPage}
          />
        );

      case FindContent.Verify:
        return (
          <Verify 
            verifyType={ACCOUNT_STATUS_TYPE.FIND_PASSWORD}
            handleNextPage={setUpdatePasswordPage}
          />
        );

      case FindContent.UpdatePassword:
        return (
          <UpdatePassword 
            onClose={onGoLogin}
          />
        );
    }
  }

  useEffect(()=> {
    setContent(FindContent.Member);
    return () => setContent(FindContent.Member);
  }, []);
  
  return (
    <>
      {isLoading ? <Spinner /> : null}
      { renderTabContent() }
    </>
    
  )
}

export default FindPassword;
